import { login, wxLogin, logout, getInfo } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { setTreeData } from '@/utils/index'

const state = {
  token: getToken(),
  name: '',
  avatar: '',
  userInfo: {},
  menus: [],
  permissions: []
}

const mutations = {
  set_token: (state, token) => {
    state.token = token
  },
  set_name: (state, name) => {
    state.name = name
  },
  set_avatar: (state, avatar) => {
    state.avatar = avatar
  },
  set_user_info: (state, userInfo) => {
    state.userInfo = userInfo
  },
  set_menus: (state, menus) => {
    state.menus = menus
  },
  set_permissions: (state, permissions) => {
    state.permissions = permissions
  }
}

const actions = {
  // user login
  login({ commit }, loginInfo) {
    const { cx_user, username, password } = loginInfo
    return new Promise((resolve, reject) => {
      login({ cx_user: cx_user, username: username.trim(), password: password }).then(resp => {
        const { success, msg, token } = resp
        if (success) {

          commit('set_token', token)
          setToken(token)
          resolve()
        } else {
          reject(msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },

  wxLogin({ commit }, loginInfo) {
    const { code, agent_id } = loginInfo
    return new Promise((resolve, reject) => {
      wxLogin({ code: code.trim(), agent_id: agent_id }).then(resp => {
        const { success, msg, token } = resp
        if (success) {
          commit('set_token', token)
          setToken(token)
          resolve()
        } else {
          reject(msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit }) {
    return new Promise((resolve, reject) => {
      getInfo().then(resp => {
        const { success, obj } = resp
        if (success) {
          const { Us, Mn, Pm } = obj
          if (Mn && Mn.length > 0) {
            // 将树形Mn转换为Array，判断菜单权限需要
            const menuArray = []
            setTreeData(Mn, (menu) => {
              menuArray.push(menu)
            })
            commit('set_menus', menuArray)
            commit('set_permissions', Pm)
            commit('set_name', Us.username)
            commit('set_user_info', Us)
            commit('set_avatar', 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif')
            resolve({ username: Us.username, menus: menuArray })
          } else {
            reject('Verification failed, please Login again.')
          }
        }
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout({ token: state.token }).then(() => {
        commit('set_token', '')
        commit('set_menus', [])
        commit('set_permissions', [])
        commit('set_name', '')
        commit('set_avatar', '')
        removeToken()
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('set_token', '')
      commit('set_menus', [])
      removeToken()
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js